import React, { useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  setEditingPolygonId,
} from "../../redux/polygonPlacement";

import FilledPolygon from "../threeDComponent/FilledPolygon";
import { useSelectObject } from "../CustomHooks";
import { colors } from "../../utils/colors";

const PlacedPolygons = () => {
  const dispatch = useDispatch();
  const { isPlacementMode, placedPolygons, editingPolygonId } = useSelector(
    (state) => state.polygonPlacement
  );

  const setExternalSelectedObjects = useCallback(
    (polygonId) => {
      dispatch(setEditingPolygonId(polygonId));
    },
    [dispatch]
  );

  const { onSingleClick, getObjectColor, onPointerEnter, onPointerLeave } =
    useSelectObject({
      externalSelectedObjects: editingPolygonId,
      setExternalSelectedObjects,
      defaultColor: colors.unclickableObject(),
    });

  const handlePolygonClick = useCallback(
    (e, polygonId) => {
      if (isPlacementMode) return;
      onSingleClick(e, polygonId);
    },
    [isPlacementMode, onSingleClick]
  );

  return placedPolygons.map((polygon) => (
    <FilledPolygon
      verts={polygon.verts}
      rotation-x={0}
      color={getObjectColor(polygon.id)}
      onClick={(e) => handlePolygonClick(e, polygon.id)}
      onPointerEnter={(e) => {
        onPointerEnter(e, polygon.id);
      }}
      onPointerLeave={onPointerLeave}
    />
  ));
};

export default PlacedPolygons;
